// @flow

import * as React from 'react'

import { Route, Switch } from 'react-router-dom'
import PrivateRoute from './privateRoute'
// Pages
import Login from '../pages/login'
import SubmissionHistory from '../pages/submissionHistory'
import NotFound from '../pages/notFound'

export default function Routes() {
  return (
    <Switch>
      <Route path="/login" exact component={Login} />
      <PrivateRoute>
        <Route path="/" exact component={SubmissionHistory} />
      </PrivateRoute>
      <Route path="*" component={NotFound} />
    </Switch>
  )
}
